import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { downloadImporter } from './actions'

function mapStateToProps(state, hocProps) {
    const contentId = hocProps.id || null

    return {
        isDownloading: state.getIn(['ui', 'userProfile', 'content', 'contents', contentId, 'showLoader'], false),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ downloadImporter }, dispatch)
}

export default (InnerComponent) => {
    @connect(mapStateToProps, mapDispatchToProps)
    class hocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return hocConnect
}
